import type { GridPaginationModel } from '@mui/x-data-grid-pro';
import is from '@sindresorhus/is';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

export const useTablePagination = (): {
    readonly paginationModel: GridPaginationModel;
    readonly resetPaginationModel: () => void;
    readonly setPaginationModel: (paginationModel: GridPaginationModel) => void;
} => {
    const {
        actions,
        applicationState: { locationSearchParams },
    } = useContext(ApplicationContext);

    const pageSize = is.numericString(locationSearchParams.get('pageSize'))
        ? Number(locationSearchParams.get('pageSize'))
        : 20;

    const page = is.numericString(locationSearchParams.get('page')) ? Number(locationSearchParams.get('page')) : 0;

    const setPaginationModel = (paginationModel: GridPaginationModel): void => {
        actions.setLocationSearchParams((prev) => {
            prev.set('page', paginationModel.page.toString());
            prev.set('pageSize', paginationModel.pageSize.toString());
            return prev;
        });
    };

    const resetPaginationModel = (): void => {
        actions.setLocationSearchParams((prev) => {
            prev.delete('page');
            prev.delete('pageSize');
            return prev;
        });
    };

    return {
        paginationModel: {
            page,
            pageSize,
        },
        resetPaginationModel,
        setPaginationModel,
    };
};
